module.exports = __webpack_public_path__ + "entry-150bfe9b/porsche-photo-e984fcccc4f988e76138f100533d349b.webp";